module.exports = __webpack_public_path__ + "static/media/date-range-arrow-right-focused.a1ba17e5.svg";